let html = `
<svg><use xlink:href="#sprite-like"></use></svg>
`

export default html